'use client';

import React, { createContext, useContext, ReactNode, useMemo } from 'react';

interface UserAgentProviderProps {
    userAgent?: string;
    children: ReactNode;
}

type userAgentContext = {
    isMobile: boolean;
};

const UserAgentContext = createContext<userAgentContext | undefined>({
    isMobile: false
});

export const UserAgentProvider: React.FC<UserAgentProviderProps> = ({ userAgent, children }) => {
    const context = useMemo(
        () => ({
            isMobile: /Mobi|Android/i.test(userAgent ?? '')
        }),
        [userAgent]
    );
    return <UserAgentContext.Provider value={context}>{children}</UserAgentContext.Provider>;
};

export const useUserAgent = (): userAgentContext => {
    const context = useContext(UserAgentContext);
    if (context === undefined) {
        throw new Error('useUserAgent must be used within a UserAgentProvider');
    }
    return context;
};
